import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { DynamicComponentContainer } from '../containers/notfound-container/dynamic-container.component';
import { UserInfoContainer } from '../containers/user.info-container/user.info-container.component';
import { NotFoundContainer } from '../containers/notfound-container/notfound-container.component';

const routes = [
  { path: ':slug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: '', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'series/:seriesSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'seasons/:seasonSlug', component: DynamicComponentContainer, pathMatch: 'full'}, // done
  { path: 'profiles/:peopleSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'events/:eventlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'places/:placeSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'pages/:pageSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'videos/:videoSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'episodes/:videoSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'streams/:videoSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'lists/:listSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'tags/:tagSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'documents/:documentSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'search/', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'playlists/:playlistSlug', component: DynamicComponentContainer, pathMatch: 'full'}, //needs to be changed to whatever (if the case)
  { path: 'playlists/:playlistSlug/videos/:videoSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'playlists/:playlistSlug/episodes/:episodeSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'embed/playlists/:playlistSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'embed/videos/:videoSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'embed/episodes/:videoSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'embed/playlists/:playlistSlug/videos/:videoSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'embed/playlists/:playlistSlug/episodes/:episodeSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: 'users/:profileSlug', component: DynamicComponentContainer, pathMatch: 'full'},
  { path: '**', component: NotFoundContainer}
];

@NgModule({
  imports: [ RouterModule.forRoot(routes, {initialNavigation: 'enabled'}) ],
  exports: [ RouterModule ]
})
export class AppRoutingModule{ }



// WEBPACK FOOTER //
// ./src/angular-framework-client-components/model/app.router.module.ts